/** The preview's API inside a same-origin frame, once it has the index; Vite may reload the frame at any time. */
export async function previewOf(frame) {
  for (let i = 0; i < 300; i++) {
    const api = frame?.contentWindow?.__EDL_DOCS_PREVIEW__;
    if (api?.indexed) return api;
    await new Promise((r) => setTimeout(r, 100));
  }
  throw new Error('the preview did not start within 30 seconds.');
}
